import React from 'react';
import PropTypes from 'prop-types';

import { FullWidthList } from './Lists.styled';
import GroupParticipantListItem from './GroupParticipantListItem.container';

export const GroupParticipantContainer = (props) => {
  return <FullWidthList {...props} />;
};

const GroupParticipantsList = ({
  users,
  compact,
  itemAction,
  isReadOnly,
  usersAdded,
}) => (
  <GroupParticipantContainer
    id="space-settings-group-participants"
    compact={compact}
  >
    {users.map((user) => (
      <GroupParticipantListItem
        key={user.id}
        user={user}
        action={itemAction}
        isReadOnly={isReadOnly}
        userAdded={usersAdded[user.id] || false}
      />
    ))}
  </GroupParticipantContainer>
);

GroupParticipantsList.propTypes = {
  users: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  usersAdded: PropTypes.shape({}),
  compact: PropTypes.bool,
  itemAction: PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    onAction: PropTypes.func,
  }),
  isReadOnly: PropTypes.bool,
};

GroupParticipantsList.defaultProps = {
  compact: false,
  itemAction: null,
  isReadOnly: false,
  usersAdded: {},
};

export default GroupParticipantsList;
